import parse from 'html-react-parser';
import React, { useContext, useState, useEffect, useMemo } from 'react';
//import { Helmet } from "react-helmet";
import {
    cleanJobTitle,
    sanitizePostal,
    buildJobURL,
    cleanJobDescHTML,
    removeMainCat,
    dateDiffInDays,
    scrollToTarget,
} from '../helpers/helpers.js';
import { Context } from './Provider.js';
import JobApplyForm from './JobApplyForm.js';
//import JobApplyFormWithValidate from "./JobApplyFormWithValidate.js";
//import MinimalForm from "./form/MinimalForm.js";

const JobDetail = () => {
    const { jobDetail, loading, data, updateJobDetail } = useContext(Context);
    const [blurState, setBlurState] = useState('blur-in');

    const {
        job_order_id,
        job_title,
        job_city,
        job_state_abbr,
        job_category,
        job_category_id,
        job_postal,
        modified_at,
        job_description,
    } = jobDetail || {};

    const jobId = job_order_id?.[0];
    const jobTitle = useMemo(() => cleanJobTitle(job_title?.[0] ?? ''), [job_title]);
    const jobCity = job_city?.[0] ?? '';
    const jobStateAbbr = job_state_abbr?.[0] ?? '';
    const jobCategory = useMemo(() => removeMainCat(job_category?.[0] ?? ''), [job_category]);
    const jobCatId = job_category_id?.[0] ?? '';
    const jobPostal = useMemo(() => sanitizePostal(job_postal?.[0]), [job_postal]);
    const jobIdFull = `${jobId}-${jobPostal}`;
    const jobPostedDateFromToday = useMemo(() => dateDiffInDays(modified_at?.[0] ?? ''), [modified_at]);
    const jobDescriptionClean = useMemo(() => parse(cleanJobDescHTML(job_description?.[0] ?? '')), [job_description]);

    const formAnchorName = 'apply';

    useEffect(() => {
        const timer = setTimeout(() => {
            if (blurState === 'blur-out') setBlurState('blur-in');
        }, 200);

        return () => clearTimeout(timer);
    }, [blurState]);

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    if (!jobDetail || loading || Object.keys(jobDetail).length === 0) {
        return null;
    }
    return (
        <article
            key={`detail-${jobIdFull}`}
            id='job-detail'
            className={`col-md-7 job-detail-column ${blurState}`}
            aria-live='polite'
            role='region'
            aria-label='Job Details'
            aria-labelledby='job-detail-headline'
        >
            <div className='sec-job-detail'>
                <h2 id='job-detail-headline' className='h5 job-detail-headline'>
                    {jobTitle}
                </h2>
                <div className='job-detail-meta'>
                    <span className='job-cat'>{jobCategory}</span>
                    <span className='job-posted'>{jobPostedDateFromToday}</span>
                    <span className='job-loc'>{jobCity}, {jobStateAbbr}</span>
                </div>
                <div className="job-detail-apply">
                    <div class="gradient-btn__container">
                        <div class="gradient-btn__gradient"></div>
                        <a 
                            href="#apply" 
                            class="gradient-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                scrollToElement(formAnchorName);
                            }}
                        >
                            <span class="gradient-btn__inner">Apply</span>
                        </a>
                    </div>
                </div>


                <div className='job-detail'>{jobDescriptionClean}</div>
                <p>
                    <em>Equal Opportunity Employer Minorities/Women/Veterans/Disabled</em>
                </p>
            </div>
            {/*<JobApplyFormValidate jobDetail={jobDetail} key={`apply-form-${jobIdFull}`} anchorID={formAnchorName} />*/}
            {/*<JobApplyFormWithValidate anchorID={formAnchorName} />*/}
            <JobApplyForm jobDetail={jobDetail} anchorID={formAnchorName} />
            {/*<MinimalForm jobDetail={jobDetail} anchorID={formAnchorName} />*/}
        </article>
    );
};

export default React.memo(JobDetail);
